import { FC, memo, useCallback, useState } from 'react';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { Modal } from 'shared/ui/Modal';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';
import { ReactComponent as InfoIcon } from 'shared/assets/icons/InfoIcon.svg';
import { ReactComponent as CloseIcon } from 'shared/assets/icons/CloseIcon.svg';
import { getSpecialPromotionContent } from '../model/selectors/getSpecialPromotionContent';
import { useSpecialPromotionModal } from '../utils/hooks/useSpecialPromotionModal';
import { Button } from 'shared/ui/Button';

export const SpecialPromotionModal: FC = memo(() => {
  const { isOpened, closeModal } = useSpecialPromotionModal();

  const [isInfoModalOpened, setInfoModalOpened] = useState(false);

  const openInfoModal = useCallback(() => {
    setInfoModalOpened(true);
  }, []);

  const closeInfoModal = useCallback(() => {
    setInfoModalOpened(false);
  }, []);

  const { isDesktop } = useScreenBreakpoints();

  const Content = useAppSelector(getSpecialPromotionContent);

  if (!Content) {
    return null;
  }

  return (
    <Modal
      width={1000}
      isOpen={isOpened}
      paddingLess
      transparent
      onClose={closeModal}
      headerItems={
        <div className="absolute top-3.5 right-6 desktop:right-2">
          <div className="flex gap-4 items-center">
            <InfoIcon
              width={isDesktop ? 35 : 25}
              height={isDesktop ? 35 : 25}
              onClick={openInfoModal}
              className="[&>path]:stroke-[#363066] cursor-pointer hover:-translate-y-1 hover:scale-110 duration-300"
            />
            <CloseIcon
              width={isDesktop ? 45 : 35}
              height={isDesktop ? 45 : 35}
              className="[&>path]:stroke-[#363066] cursor-pointer hover:-translate-y-1 hover:scale-105 duration-300"
              onClick={closeModal}
            />
          </div>
        </div>
      }
      closeIcon={false}
    >
      <Content />
      <Modal isOpen={isInfoModalOpened} onClose={closeInfoModal} width={isDesktop ? 600 : 380}>
        <div className="flex flex-col text-center items-center gap-4 max-w-[380px] desktop:max-w-[800px]">
          <div className="text-xl desktop:text-2xl font-bold">Angebotsbedingungen</div>
          <div className="text-lg desktop:text-xl font-semibold">Osteraktion 2025</div>
          <div className="flex flex-col text-primaryLight gap-2 [&>span]:font-normal [&>span]:text-[10px] [&>span]:desktop:text-[14px] text-left">
            <div className="text-sm desktop:text-lg">Mindestmietdauer: 1 Monat</div>
            <div className="text-sm desktop:text-lg">Abrechnung:</div>
            <span> 1. Sie erhalten 25% Rabatt auf die Monatsmiete</span>
            <span> 2. Für so viele Monate, wie Ihre Lagerbox Quadratmeter hat</span>
            <span> 3. Beispiele:</span>
            <span> - Bei einer 3m² - Box erhalten Sie in den ersten 3 Monaten jeweils 25% Rabatt auf die Miete (zzgl. Versicherung)</span>
            <span> - Bei einer 3,5 m² - Box gilt der Rabatt für 3 Monate – es wird immer auf die volle Quadratmeterzahl abgerundet</span>
            <div className="text-sm desktop:text-lg">Vertragsverlängerung:</div>
            <span>
              Nach Ablauf der Mindestmietdauer verlängert sich der Vertrag automatisch monatlich, bis er unter Einhaltung einer
              Kündigungsfrist von 14 Tagen gekündigt wird.
            </span>
            <div className="text-sm desktop:text-lg">Gültig nur für Neukunden</div>
            <div className="text-sm desktop:text-lg">Nicht kombinierbar mit anderen Rabatten oder Aktionen</div>
            <span>Es gelten die allgemeinen Geschäftsbedingungen des Vertrags</span>
          </div>
          <Button
            containerClassName="min-w-[255px] max-w-[380px]"
            className="!bg-[#DD4742]"
            fontColor="text-white"
            fontSize={isDesktop ? 'large' : 'medium'}
            onClick={closeInfoModal}
          >
            Zurück
          </Button>
        </div>
      </Modal>
    </Modal>
  );
});
